import config from '@/config';

const selfRegistrationBlock = () => {
  // TODO get backend env ENABLE_AUTO_REGISTRATION in authorization-server
  const isAuthBradesco =
    config.authorizationServer === 'authbra.intellisign.com';
  const isAppBraUrl = window.location.href.includes('appbra.');
  // When is Bradesco Version, needs block auto registration
  return isAuthBradesco || isAppBraUrl;
};

const getAuthorizationLinkBase = (locale) => {
  if (config.authorizationServer) {
    return `${config.authorizationServer}`;
  }
  //fallback by language
  if (locale === 'en') {
    return `https://login.intellisign.com`;
  }
  return `https://auth.intellisign.com`;
};

export default {
  isSelfRegistrationBlock: selfRegistrationBlock,
  getAuthorizationLinkBase: getAuthorizationLinkBase,
};
